import React from "react";
import SharedHeroSection from "./SharedHeroSection";

export default function ServiceHeroSection({
  badge = "Service",
  title = (
    <>
      <span className="bg-gradient-to-r from-blue-400 via-indigo-400 to-purple-400 bg-clip-text text-transparent">
        Service
      </span>
      <br /> Solutions
    </>
  ),
  description = "We build tailored digital experiences that help businesses grow, engage users better, and operate with confidence.",
  media = null,
}) {
  return (
    <SharedHeroSection
      badge={badge}
      title={title}
      description={description}
      containerClassName="min-h-[70vh]"
      split
      media={media}
      titleClassName="text-left"
      descriptionClassName="text-left max-w-xl"
      contentClassName="max-w-2xl"
    />
  );
}
